export const MAINTENANCE_CONFIG = {
  defaultMessage:
    'We are currently performing scheduled maintenance. Please check back soon.',
  tokenExpirationHours: 24,
  rateLimitAttempts: 5,
  rateLimitWindowMinutes: 15,
  bypassTokenKey: 'maintenance_bypass_token',
  attemptStorageKey: 'maintenance_attempts'
}

export const getBypassToken = () => {
  try {
    return localStorage.getItem(MAINTENANCE_CONFIG.bypassTokenKey)
  } catch (error) {
    console.error('Error getting bypass token:', error)
    return null
  }
}

export const setBypassToken = (token) => {
  try {
    localStorage.setItem(MAINTENANCE_CONFIG.bypassTokenKey, token)
    const expiration = new Date()
    expiration.setHours(
      expiration.getHours() + MAINTENANCE_CONFIG.tokenExpirationHours
    )
    localStorage.setItem(
      `${MAINTENANCE_CONFIG.bypassTokenKey}_expiration`,
      expiration.toISOString()
    )
  } catch (error) {
    console.error('Error setting bypass token:', error)
  }
}

export const clearBypassToken = () => {
  try {
    localStorage.removeItem(MAINTENANCE_CONFIG.bypassTokenKey)
    localStorage.removeItem(`${MAINTENANCE_CONFIG.bypassTokenKey}_expiration`)
  } catch (error) {
    console.error('Error clearing bypass token:', error)
  }
}

export const isBypassTokenValid = () => {
  try {
    const token = getBypassToken()
    if (!token) return false

    const expirationStr = localStorage.getItem(
      `${MAINTENANCE_CONFIG.bypassTokenKey}_expiration`
    )
    if (!expirationStr) return false

    const expiration = new Date(expirationStr)
    const now = new Date()

    return now < expiration
  } catch (error) {
    console.error('Error checking bypass token validity:', error)
    return false
  }
}

export const getRateLimitAttempts = () => {
  try {
    const attemptsStr = localStorage.getItem(
      MAINTENANCE_CONFIG.attemptStorageKey
    )
    if (!attemptsStr) return []

    const attempts = JSON.parse(attemptsStr)
    const now = new Date()
    const windowMs = MAINTENANCE_CONFIG.rateLimitWindowMinutes * 60 * 1000

    return attempts.filter((attempt) => {
      const attemptTime = new Date(attempt.timestamp)
      return now - attemptTime < windowMs
    })
  } catch (error) {
    console.error('Error getting rate limit attempts:', error)
    return []
  }
}

export const recordRateLimitAttempt = () => {
  try {
    const attempts = getRateLimitAttempts()
    attempts.push({ timestamp: new Date().toISOString() })
    localStorage.setItem(
      MAINTENANCE_CONFIG.attemptStorageKey,
      JSON.stringify(attempts)
    )
  } catch (error) {
    console.error('Error recording rate limit attempt:', error)
  }
}

export const isRateLimitExceeded = () => {
  const attempts = getRateLimitAttempts()
  return attempts.length >= MAINTENANCE_CONFIG.rateLimitAttempts
}

export const clearRateLimitAttempts = () => {
  try {
    localStorage.removeItem(MAINTENANCE_CONFIG.attemptStorageKey)
  } catch (error) {
    console.error('Error clearing rate limit attempts:', error)
  }
}
